module.exports = __webpack_public_path__ + "img/titles11.6a879c62.png";